<div class="project-info-container">

  <!-- ================= ADD / EDIT BUTTONS ================= -->
  <div class="mode-buttons">

    <button
      mat-raised-button
      type="button"
      class="project-details-button"
      (click)="onModeChange('add')"
      [disabled]="mode === 'add'"
    >
      Add
    </button>

    <button
      mat-raised-button
      type="button"
      class="project-details-button"
      (click)="onModeChange('edit')"
      [disabled]="mode === 'edit'"
    >
      Edit
    </button>

  </div>


  <form [formGroup]="projectForm">

    <!-- ================= EDIT MODE SELECTION ================= -->
    <div
      *ngIf="mode === 'edit'"
      class="edit-selection-section"
    >

      <div class="edit-selection-grid">

        <div
          class="field-wrapper select-field"
          [class.has-value]="projectForm.get('client')?.value"
        >
          <label>
            Select a client <span class="required">*</span>
          </label>

          <ng-select
            [items]="clientsList"
            formControlName="client"
            placeholder=""
            [clearable]="true"
            (change)="onClientChange($event)"
          >
          </ng-select>
        </div>


        <div
          class="field-wrapper select-field"
          [class.has-value]="projectForm.get('project')?.value"
        >
          <label>
            Select a project <span class="required">*</span>
          </label>

          <ng-select
            [items]="projectsList"
            formControlName="project"
            placeholder=""
            (change)="onProjectChange($event)"
          >
          </ng-select>
        </div>

      </div>

    </div>


    <!-- ================= MAIN TWO COLUMN SECTION ================= -->
    <div class="main-details-grid">


      <!-- ================= PROJECT DETAILS ================= -->
      <section class="details-card">

        <h3>Project Details</h3>


        <!-- ================= ADD MODE ================= -->
        <ng-container *ngIf="mode === 'add'">

          <!-- CLIENT | MANAGER -->
          <div class="field-row">

            <div
              class="field-wrapper select-field"
              [class.has-value]="projectForm.get('client')?.value"
            >
              <label>
                Select a client <span class="required">*</span>
              </label>

              <ng-select
                [items]="clientsList"
                formControlName="client"
                placeholder=""
                [clearable]="true"
                (change)="onClientChange($event)"
              >
              </ng-select>
            </div>


            <div
              class="field-wrapper select-field"
              [class.has-value]="projectForm.get('projectManager')?.value"
            >
              <label>
                Select a Manager <span class="required">*</span>
              </label>

              <ng-select
                [items]="employeesList"
                formControlName="projectManager"
                placeholder=""
              >
              </ng-select>
            </div>

          </div>

        </ng-container>


        <!-- ================= PROJECT CODE | PROJECT TYPE ================= -->
        <div class="field-row">

          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('projectCode')?.value"
          >
            <label>
              {{ mode === 'add' ? 'Add Project Code' : 'Project Code' }}
              <span class="required">*</span>
            </label>

            <ng-select
              [items]="projectCodeOptions"
              bindLabel="label"
              bindValue="value"
              [itemDisabled]="'disabled'"
              [addTag]="mode === 'add' ? addProjectCode : null"
              [multiple]="false"
              formControlName="projectCode"
              placeholder=""
              [maxLength]="4"
              (keydown)="restrictPRCodeLength($event)"
              (change)="onProjectCodeChange($event)"
              [readonly]="mode === 'edit'"
            >
            </ng-select>
          </div>


          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('projectType')?.value"
          >
            <label>
              Select a project type <span class="required">*</span>
            </label>

            <ng-select
              [items]="projectTypesList"
              formControlName="projectType"
              placeholder=""
            >
            </ng-select>
          </div>

        </div>


        <!-- ================= PROJECT DESCRIPTION ================= -->
        <div class="field-wrapper floating-field full-width project-description-field">

          <textarea
            cdkTextareaAutosize
            cdkAutosizeMaxRows="2"
            formControlName="projectDescription"
            placeholder=" "
          ></textarea>

          <span class="floating-label">
            Project Description <span class="required">*</span>
          </span>

        </div>


        <!-- ================= EDIT MODE: MANAGER | SHORT CODE ================= -->
        <div
          *ngIf="mode === 'edit'"
          class="field-row manager-shortcode-row"
        >

          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('projectManager')?.value"
          >
            <label>
              Select a Manager <span class="required">*</span>
            </label>

            <ng-select
              [items]="employeesList"
              formControlName="projectManager"
              placeholder=""
            >
            </ng-select>
          </div>


          <div class="field-wrapper floating-field">

            <input
              type="text"
              formControlName="shortCode"
              placeholder=" "
              readonly
            />

            <span class="floating-label">
              Short Code <span class="required">*</span>
            </span>

          </div>

        </div>


        <!-- ================= OLD CODE | INTERNAL ================= -->
        <div class="field-row checkbox-row">

          <div class="checkbox-field">
            <label for="oldCodeCheck">

              <span>Old Code</span>

              <input
                type="checkbox"
                id="oldCodeCheck"
                formControlName="oldCode"
              />

            </label>
          </div>


          <div class="checkbox-field">
            <label for="internalCheck">

              <span>Internal</span>

              <input
                type="checkbox"
                id="internalCheck"
                formControlName="internal"
              />

            </label>
          </div>

        </div>


        <!-- ================= COMPANY | PAYMENT DAYS ================= -->
        <div class="field-row">

          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('billingCompany')?.value"
          >
            <label>
              Select a Company <span class="required">*</span>
            </label>

            <ng-select
              [items]="companiesList"
              formControlName="billingCompany"
              placeholder=""
            >
            </ng-select>
          </div>


          <div class="field-wrapper floating-field">

            <input
              type="number"
              formControlName="paymentDays"
              min="0"
              placeholder=" "
            />

            <div
              class="validation-error"
              *ngIf="projectForm.get('paymentDays')?.hasError('min')"
            >
              Payment Days can't be negative.
            </div>

            <span class="floating-label">
              Payment Days <span class="required">*</span>
            </span>

          </div>

        </div>


        <!-- ================= ADD MODE: SHORT CODE NOT SHOWN ================= -->

      </section>


      <!-- ================= CONTACT DETAILS ================= -->
      <section class="details-card">

        <h3>Contact Details</h3>


        <!-- CONTACT MODE -->
        <div class="contact-mode">

          <label>

            <input
              type="radio"
              value="ADD-NEW"
              formControlName="contactMode"
              (change)="onContactModeChange('ADD-NEW')"
            />

            Add Contact <span class="required">*</span>

          </label>


          <label>

            <input
              type="radio"
              value="SEL-CONT"
              formControlName="contactMode"
              (change)="onContactModeChange('SEL-CONT')"
            />

            Select from existing contacts <span class="required">*</span>

          </label>

        </div>


        <!-- SELECT CONTACT | CONTACT NAME -->
        <div class="field-row contact-row">

          <!-- SELECT CONTACT -->
          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('availableContacts')?.value"
          >

            <label>
              Select a contact <span class="required">*</span>
            </label>

            <ng-select
              [items]="availableContactsList"
              formControlName="availableContacts"
              placeholder=""
              [clearable]="true"
              (change)="onAvailableContactChange($event)"
            >
            </ng-select>

          </div>


          <!-- CONTACT NAME -->
          <div class="field-wrapper floating-field contact-name-field">

            <input
              type="text"
              formControlName="contact"
              placeholder=" "
            />

            <span class="floating-label">
              Contact Name
              <span
                class="required"
                *ngIf="projectForm.get('contactMode')?.value === 'ADD-NEW'"
              >
                *
              </span>
            </span>

          </div>

        </div>


        <!-- ADDRESS -->
        <div class="field-wrapper floating-field full-width">

          <textarea
            cdkTextareaAutosize
            cdkAutosizeMaxRows="2"
            formControlName="address"
            placeholder=" "
          ></textarea>

          <span class="floating-label">
            Address
          </span>

        </div>


        <!-- TELEPHONE -->
        <div class="field-wrapper floating-field full-width">

          <input
            type="text"
            formControlName="telephone"
            placeholder=" "
          />

          <span class="floating-label">
            Telephone
          </span>

        </div>


        <!-- COUNTRY | STATE -->
        <div class="field-row">

          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('country')?.value"
          >

            <label>
              Country <span class="required">*</span>
            </label>

            <ng-select
              [items]="countriesList"
              formControlName="country"
              placeholder=""
              (change)="onCountryChange($event)"
            >
            </ng-select>

          </div>


          <div
            class="field-wrapper select-field"
            [class.has-value]="projectForm.get('state')?.value"
          >

            <label>
              State <span class="required" *ngIf="statesList.length > 0">*</span>
            </label>

            <ng-select
              [items]="statesList"
              bindLabel="stateName"
              bindValue="stateName"
              formControlName="state"
              placeholder=""
              (change)="onStateChange()"
            >
            </ng-select>

          </div>

        </div>

      </section>

    </div>


    <!-- ================= ACTION BUTTONS ================= -->
    <div class="action-row">

      <button
        *ngIf="mode === 'add'"
        mat-raised-button
        type="button"
        class="submit-button"
        [disabled]="projectForm.invalid"
        (click)="onSubmitProjectDetails()"
      >
        <mat-icon>add</mat-icon>
        Submit
      </button>


      <button
        *ngIf="mode === 'edit'"
        mat-raised-button
        type="button"
        class="save-button"
        [disabled]="isViewOtherDetailsDisabled"
        (click)="onSaveProjectDetails()"
      >
        <mat-icon>save</mat-icon>
        Save
      </button>


      <button
        mat-raised-button
        type="button"
        class="delete-button"
        (click)="onClearProjectDetails()"
      >
        <mat-icon>clear</mat-icon>
        Clear
      </button>

    </div>

  </form>


  <!-- ================= THEME ALLOCATION ================= -->
  <section
    *ngIf="(mode === 'add' && !isAddOtherDetailsDisabled) || (mode === 'edit' && !isViewOtherDetailsDisabled)"
    class="details-card theme-allocation-card"
  >

    <h3>Theme Allocation</h3>


    <form [formGroup]="themeForm">

      <div class="field-row">

        <div
          class="field-wrapper select-field"
          [class.has-value]="themeForm.get('theme')?.value"
        >

          <label>
            Select a Theme <span class="required">*</span>
          </label>

          <ng-select
            [items]="themesList"
            bindLabel="themeDesc"
            bindValue="themeDesc"
            formControlName="theme"
            placeholder=""
          >
          </ng-select>

        </div>


        <div class="field-wrapper floating-field">

          <input
            type="number"
            formControlName="allocation"
            placeholder=" "
            min="0"
            max="100"
          />
          <div
            class="validation-error"
            *ngIf="themeForm.get('allocation')?.hasError('min')
                  && themeForm.get('allocation')?.touched"
          >
            Allocation can't be negative.
          </div>

          <div
            class="validation-error"
            *ngIf="themeForm.get('allocation')?.hasError('max')
                  && themeForm.get('allocation')?.touched"
          >
            Allocation can't be more than 100.
          </div>

          <span class="floating-label">
            Allocation % <span class="required">*</span>
          </span>

        </div>

      </div>


      <div class="action-row theme-action-row">

        <button
          mat-raised-button
          type="button"
          class="submit-button"
          [disabled]="themeForm.invalid"
          (click)="onSubmitThemeAllocation()"
        >
          <mat-icon>add</mat-icon>
          Submit
        </button>

        <button
          mat-raised-button
          type="button"
          class="delete-button"
          (click)="onOpenThemeAllocationDialog()"
        >
          <mat-icon>remove_red_eye</mat-icon>
          View
        </button>

        <div class="flex-grow"></div>

        <button
          mat-raised-button
          type="button"
          class="submit-button"
          (click)="onNextTab()"
        >
          <mat-icon>skip_next</mat-icon>
          Next
        </button>

      </div>

    </form>

  </section>

</div>